import React from 'react';
import { Shield, Calendar, Clock, MapPin, Users, DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';
export function WomensSelfDefenseContent() {
  return <section className="py-16 bg-[#0a0a0a]" data-id="element-1956">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1957">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1958">
          {/* Left Column — Details */}
          <div data-id="element-1959">
            {/* Price Badge */}
            <div className="inline-flex items-center gap-2 bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] font-bold text-2xl px-6 py-3 rounded-lg mb-8" data-id="element-1960">
              <DollarSign className="w-6 h-6" data-id="element-1961" />
              $35.00
            </div>

            <h2 className="text-2xl font-bold text-white mb-2" data-id="element-1962">
              Women • Mothers • Daughters
            </h2>
            <div className="w-16 h-1 bg-[#00D4FF] mb-8" data-id="element-1963" />

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-1964">
              <p data-id="element-1965">
                Every woman deserves the confidence and skills to protect
                herself.
              </p>
              <p data-id="element-1966">
                Join Walker's Martial Arts for a{' '}
                <strong className="text-white" data-id="element-1967">
                  Women's Self-Defense Seminar
                </strong>{' '}
                focused on awareness, prevention, and practical self-defense
                skills for real-world situations. This seminar is designed for{' '}
                <strong className="text-white" data-id="element-1968">
                  women and teen girls ages 13+
                </strong>{' '}
                and is open to the community.
              </p>
              <p data-id="element-1969">
                Participants will learn simple, effective concepts to help
                recognize danger early, respond confidently, and protect
                themselves if necessary.
              </p>
            </div>

            {/* Event Details Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10" data-id="element-1970">
              <div className="animate-scroll-fade-up bg-[#1a1a1a] p-5 rounded-xl border border-gray-800 flex items-start gap-4" data-id="element-1971">
                <Calendar className="w-6 h-6 text-[#00D4FF] shrink-0 mt-0.5" data-id="element-1972" />
                <div data-id="element-1973">
                  <p className="text-white font-semibold" data-id="element-1974">Saturday, April 18</p>
                  <p className="text-gray-400 text-sm" data-id="element-1975">2026</p>
                </div>
              </div>
              <div className="animate-scroll-fade-up bg-[#1a1a1a] p-5 rounded-xl border border-gray-800 flex items-start gap-4" style={{
              animationDelay: '0.1s'
            }} data-id="element-1976">
                <Clock className="w-6 h-6 text-[#00D4FF] shrink-0 mt-0.5" data-id="element-1977" />
                <div data-id="element-1978">
                  <p className="text-white font-semibold" data-id="element-1979">1:00 – 3:00 PM</p>
                  <p className="text-gray-400 text-sm" data-id="element-1980">2 hour session</p>
                </div>
              </div>
              <div className="animate-scroll-fade-up bg-[#1a1a1a] p-5 rounded-xl border border-gray-800 flex items-start gap-4" style={{
              animationDelay: '0.2s'
            }} data-id="element-1981">
                <MapPin className="w-6 h-6 text-[#00D4FF] shrink-0 mt-0.5" data-id="element-1982" />
                <div data-id="element-1983">
                  <p className="text-white font-semibold" data-id="element-1984">
                    Walker's Martial Arts
                  </p>
                  <p className="text-gray-400 text-sm" data-id="element-1985">
                    1304 E. Empire, Bloomington
                  </p>
                </div>
              </div>
              <div className="animate-scroll-fade-up bg-[#1a1a1a] p-5 rounded-xl border border-gray-800 flex items-start gap-4" style={{
              animationDelay: '0.3s'
            }} data-id="element-1986">
                <Users className="w-6 h-6 text-[#00D4FF] shrink-0 mt-0.5" data-id="element-1987" />
                <div data-id="element-1988">
                  <p className="text-white font-semibold" data-id="element-1989">Women & Teen Girls</p>
                  <p className="text-gray-400 text-sm" data-id="element-1990">Ages 13+</p>
                </div>
              </div>
            </div>

            {/* What You'll Learn */}
            <div className="mt-12" data-id="element-1991">
              <h3 className="text-xl font-bold text-white mb-6" data-id="element-1992">
                What You'll Learn
              </h3>
              <ul className="space-y-4" data-id="element-1993">
                {['Situational awareness & recognizing danger early', 'Prevention strategies to avoid confrontation', 'Simple, effective self-defense techniques', 'How to respond confidently under pressure', 'Empowerment through preparation'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-1994">
                    <Shield className="w-5 h-5 text-[#00D4FF] shrink-0 mt-0.5" data-id="element-1995" />
                    <span className="text-gray-300" data-id="element-1996">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* CTA */}
            <div className="mt-12 flex flex-col sm:flex-row gap-4" data-id="element-1997">
              <Link to="/contact" className="bg-[#00D4FF] text-black px-8 py-4 rounded font-bold text-lg uppercase tracking-wider hover:bg-[#33ddff] transition-all flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)]" data-id="element-1998">
                Register Now — $35
              </Link>
              <Link to="/contact" className="px-8 py-4 rounded font-bold text-lg uppercase tracking-wider text-white border border-white/30 hover:bg-white/10 transition-all flex items-center justify-center gap-2" data-id="element-1999">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Right Column — Promotional Image & Urgency */}
          <div className="space-y-8" data-id="element-2000">
            {/* Why This Matters */}
            <div className="animate-scroll-fade-up bg-[#1a1a1a] rounded-2xl border border-gray-800 p-8" data-id="element-2001">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-2002">
                <span className="text-2xl" data-id="element-2003">⚠️</span>
                Why This Matters
              </h3>
              <div className="space-y-4 text-gray-300" data-id="element-2004">
                <p data-id="element-2005">
                  <strong className="text-[#FF6B35]" data-id="element-2006">
                    Bad things happen to good people — be prepared.
                  </strong>
                </p>
                <div className="bg-[#2a2a2a] rounded-xl p-6 mt-2" data-id="element-2007">
                  <h4 className="text-white font-bold text-base uppercase tracking-wide mb-4" data-id="element-2008">
                    Recent Assault Headlines
                  </h4>
                  <ul className="space-y-3 text-sm text-gray-300" data-id="element-2009">
                    <li className="flex items-start gap-2" data-id="element-2010">
                      <span className="text-gray-400 mt-0.5" data-id="element-2011">•</span>
                      <span data-id="element-2012">
                        <strong className="text-white" data-id="element-2013">Naperville:</strong>{' '}
                        Walgreens Restroom Assault
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2014">
                      <span className="text-gray-400 mt-0.5" data-id="element-2015">•</span>
                      <span data-id="element-2016">
                        <strong className="text-white" data-id="element-2017">Bloomington:</strong>{' '}
                        Grooming and Abuse Investigation
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2018">
                      <span className="text-gray-400 mt-0.5" data-id="element-2019">•</span>
                      <span data-id="element-2020">
                        <strong className="text-white" data-id="element-2021">McLean County:</strong>{' '}
                        Predatory Criminal Sexual Assault Charges Filed
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-2022">
                      <span className="text-gray-400 mt-0.5" data-id="element-2023">•</span>
                      <span data-id="element-2024">
                        <strong className="text-white" data-id="element-2025">Peoria:</strong> Man
                        Charged in Sexual Assault of Teen Girl
                      </span>
                    </li>
                  </ul>
                </div>
                <p className="text-sm leading-relaxed" data-id="element-2026">
                  This seminar gives you real skills for real situations —
                  practical knowledge you can use immediately to protect
                  yourself and your loved ones.
                </p>
              </div>
            </div>

            {/* Open to Community */}
            <div className="animate-scroll-fade-up bg-gradient-to-br from-[#00D4FF]/10 to-transparent rounded-2xl border border-[#00D4FF]/20 p-8" data-id="element-2027">
              <h3 className="text-lg font-bold text-[#00D4FF] mb-3" data-id="element-2028">
                Open to the Community
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-2029">
                You do not need to be a current student at Walker's Martial Arts
                to attend. This seminar is open to all women and teen girls ages
                13+ in the Bloomington-Normal area and beyond. Bring your
                mothers, daughters, sisters, and friends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}